module.exports = __webpack_public_path__ + "img/chart-vertical.23fd8a65.svg";